export const items = [
  {
    id: 71,
    general_observation: 'Observação medico',
    status: 'analyze',
    time: {
      requested_time: null,
      justificative: null,
      predicted_time: '02:00',
      surgery_time: null
    },
    surgery_day: null,
    equipaments: [],
    appointments: [
      {
        room_id: 38,
        start_date: '2023-03-31T08:30:00.000Z',
        end_date: '2023-03-31T10:30:00.000Z',
        justificative: '',
        any_time: false,
        status: 'pre-scheduling',
        is_main: true,
        scheduling: null,
        id: 93,
        hour: '08:30',
        time: '02:00',
        is_preferential: false
      }
    ],
    anesthetist: {
      type: 'scale'
    },
    createdAt: '2023-03-21T13:28:02.000Z',
    updatedAt: '2023-03-21T13:28:02.000Z',
    requested_by_name: 'MATHEUS MAGALHAES DOS SANTOS R JUNQUEIRA',
    requested_by_id: 17515,
    scheduled_by_name: null,
    scheduled_by_id: null,
    surgical_order: {
      id: 545184,
      patient_internal: false,
      tecnic: 'Convencional',
      freezing: false,
      hospital_id: 6,
      room_id: 11,
      blood_reserve: false,
      cti: false,
      hospital_name: null,
      health_insurance: {
        id: 151482,
        name: 'COPASS'
      },
      patient_urgency: false,
      procedures: [
        {
          isMain: true,
          code: '31001076',
          description: 'ESOFAGOPLASTIA (GASTROPLASTIA)',
          quantity: 1,
          surgery_id: 124
        }
      ],
      surgery_center_name: 'CENTRO CIRURGICO (C)'
    },
    doctor: {
      id: 17138,
      name: 'MATHEUS MAGALHAES DOS SANTOS R JUNQUEIRA'
    },
    patient: {
      name: 'CAMILA ROBERTA REIS NICACIO',
      id: 314023,
      birthday: '1998-01-03T00:00:00.000Z'
    },
    observation_to_scheduling_is_another_date: null,
    reason_to_scheduling_is_another_date: null
  },
  {
    id: 77,
    general_observation: 'observacao',
    status: 'analyze',
    time: {
      requested_time: null,
      justificative: null,
      predicted_time: '04:00',
      surgery_time: '03:30'
    },
    surgery_day: null,
    equipaments: [
      {
        name: 'EQUIPAMENTO DE HEMODINAMICA',
        code: 216,
        isSolicitation: false
      },
      {
        name: 'any_name_equipament_no_exists_mv',
        isSolicitation: true
      }
    ],
    appointments: [
      {
        room_id: 38,
        start_date: '2023-04-01T08:30:00.000Z',
        end_date: '2023-04-01T12:30:00.000Z',
        justificative: '',
        any_time: false,
        status: 'pre-scheduling',
        is_main: true,
        scheduling: null,
        id: 149,
        hour: '08:30',
        time: '04:00',
        is_preferential: false
      },
      {
        room_id: 1,
        start_date: '2023-04-01T09:00:00.000Z',
        end_date: '2023-04-01T12:30:00.000Z',
        justificative: 'justificative',
        any_time: false,
        status: 'scheduled',
        is_main: true,
        scheduling: null,
        id: 150,
        hour: '09:00',
        time: '03:30',
        is_preferential: true
      }
    ],
    anesthetist: {
      type: 'choose-anesthetist',
      code: 31835,
      name: 'FELIPE BELLO TORRES'
    },
    createdAt: '2023-03-21T19:48:43.000Z',
    updatedAt: '2023-03-21T19:50:39.000Z',
    requested_by_name: 'MATHEUS MAGALHAES DOS SANTOS R JUNQUEIRA',
    requested_by_id: 17515,
    scheduled_by_name: 'scheduled_by_name',
    scheduled_by_id: 1,
    surgical_order: {
      id: 545183,
      patient_internal: false,
      tecnic: 'Convencional',
      freezing: false,
      hospital_id: 6,
      room_id: 11,
      blood_reserve: false,
      cti: false,
      hospital_name: null,
      health_insurance: {
        id: 151481,
        name: 'COPASS'
      },
      patient_urgency: false,
      procedures: [
        {
          isMain: true,
          code: '30719089',
          description: 'FRATURAS/PSEUDARTROSES/ARTROSE C/ FIXADO',
          quantity: 1,
          surgery_id: 1377
        },
        {
          isMain: false,
          code: '40813398',
          description: 'DILATACAO PERCUTANEA DE ESTENOSE DE DUCTO PANCREATICO',
          quantity: 1,
          surgery_id: 6221
        }
      ],
      surgery_center_name: 'CENTRO CIRURGICO (C)'
    },
    doctor: {
      id: 17138,
      name: 'MATHEUS MAGALHAES DOS SANTOS R JUNQUEIRA'
    },
    patient: {
      name: 'CAMILA ROBERTA REIS NICACIO',
      id: 314023,
      birthday: '1998-01-03T00:00:00.000Z'
    },
    observation_to_scheduling_is_another_date:
      'observation_to_scheduling_is_another_date',
    reason_to_scheduling_is_another_date:
      'observation_to_scheduling_is_another_date'
  },
  {
    id: 91,
    general_observation:
      'Favor verificar se seria possivel agenda na sala 18 pois é uma sala maior e mais iluminada. Seria bom pois vou solicitar alguns equipamentos e vou precisar de Raio X.',
    status: 'analyze',
    time: {
      requested_time: '03:00',
      justificative: 'teste',
      predicted_time: '02:00',
      surgery_time: null
    },
    surgery_day: null,
    equipaments: [],
    appointments: [
      {
        room_id: 38,
        start_date: '2023-03-29T15:00:00.000Z',
        end_date: '2023-03-29T18:00:00.000Z',
        justificative: '',
        any_time: false,
        status: 'pre-scheduling',
        is_main: true,
        scheduling: null,
        id: 178,
        hour: '15:00',
        time: '03:00',
        is_preferential: false
      }
    ],
    anesthetist: {
      type: 'local-anesthesia'
    },
    createdAt: '2023-03-22T19:14:43.000Z',
    updatedAt: '2023-03-22T19:14:43.000Z',
    requested_by_name: 'MATHEUS MAGALHAES DOS SANTOS R JUNQUEIRA',
    requested_by_id: 17515,
    scheduled_by_name: null,
    scheduled_by_id: null,
    surgical_order: {
      id: 545090,
      patient_internal: false,
      tecnic: 'Convencional',
      freezing: false,
      hospital_id: 6,
      room_id: 11,
      blood_reserve: false,
      cti: false,
      hospital_name: null,
      health_insurance: {
        id: 151382,
        name: 'PARTICULAR'
      },
      patient_urgency: false,
      procedures: [
        {
          isMain: true,
          code: '30722098',
          description: 'AMPUTACAO TRANSMETACARPIANA COM TRANSPOSICAO DE DEDO',
          quantity: 1,
          surgery_id: 633
        },
        {
          isMain: false,
          code: '30911087',
          description: 'CATETERISMO CARDÍACO E E/OU D COM CINEAN',
          quantity: 1,
          surgery_id: 5838
        },
        {
          isMain: false,
          code: '30715598',
          description: 'ARTROPLASTIA DISCAL DE COLUNA VERTEBRAL',
          quantity: 1,
          surgery_id: 6623
        },
        {
          isMain: false,
          code: '31005675',
          description: 'BIOPSIA HEPATICA POR VIDEOLAPAROSCOPIA',
          quantity: 1,
          surgery_id: 6104
        }
      ],
      surgery_center_name: 'CENTRO CIRURGICO (C)'
    },
    doctor: {
      id: 17138,
      name: 'MATHEUS MAGALHAES DOS SANTOS R JUNQUEIRA'
    },
    patient: {
      name: 'CAMILA ROBERTA REIS NICACIO',
      id: 314023,
      birthday: '1998-01-03T00:00:00.000Z'
    },
    observation_to_scheduling_is_another_date: null,
    reason_to_scheduling_is_another_date: null
  },
  {
    id: 102,
    general_observation: 'dfgdfgbdg fd',
    status: 'analyze',
    time: {
      requested_time: '02:00',
      justificative: 'twetwetrw',
      predicted_time: '00:30',
      surgery_time: null
    },
    surgery_day: null,
    equipaments: [],
    appointments: [
      {
        room_id: 38,
        start_date: '2023-04-06T08:30:00.000Z',
        end_date: '2023-04-06T10:30:00.000Z',
        justificative: '',
        any_time: false,
        status: 'pre-scheduling',
        is_main: true,
        scheduling: null,
        id: 201,
        hour: '08:30',
        time: '02:00',
        is_preferential: false
      }
    ],
    anesthetist: {
      type: 'scale'
    },
    createdAt: '2023-03-23T13:36:08.000Z',
    updatedAt: '2023-03-23T13:36:08.000Z',
    requested_by_name: 'MATHEUS MAGALHAES DOS SANTOS R JUNQUEIRA',
    requested_by_id: 17515,
    scheduled_by_name: null,
    scheduled_by_id: null,
    surgical_order: {
      id: 545194,
      patient_internal: false,
      tecnic: 'Convencional',
      freezing: true,
      hospital_id: 6,
      room_id: 11,
      blood_reserve: true,
      cti: false,
      hospital_name: null,
      health_insurance: {
        id: 151494,
        name: 'AMIL'
      },
      patient_urgency: true,
      procedures: [
        {
          isMain: true,
          code: '40813878',
          description: 'ACESSO PERCUTANEO PARA NEFROSCOPIA',
          quantity: 1,
          surgery_id: 2375
        }
      ],
      surgery_center_name: 'CENTRO CIRURGICO (C)'
    },
    doctor: {
      id: 17138,
      name: 'MATHEUS MAGALHAES DOS SANTOS R JUNQUEIRA'
    },
    patient: {
      name: 'TIAGO DE MORAIS',
      id: 151192,
      birthday: '1986-11-05T00:00:00.000Z'
    },
    observation_to_scheduling_is_another_date: null,
    reason_to_scheduling_is_another_date: null
  },
  {
    id: 108,
    general_observation: 'teste',
    status: 'analyze',
    time: {
      requested_time: '03:00',
      justificative: 'teste',
      predicted_time: '00:30',
      surgery_time: null
    },
    surgery_day: null,
    equipaments: [],
    appointments: [
      {
        room_id: 38,
        start_date: '2023-03-29T12:00:00.000Z',
        end_date: '2023-03-29T15:00:00.000Z',
        justificative: '',
        any_time: true,
        status: 'pre-scheduling',
        is_main: true,
        scheduling: null,
        id: 215,
        hour: '',
        time: '03:00',
        is_preferential: false
      }
    ],
    anesthetist: {
      type: 'scale'
    },
    createdAt: '2023-03-23T19:47:32.000Z',
    updatedAt: '2023-03-23T19:47:32.000Z',
    requested_by_name: 'MATHEUS MAGALHAES DOS SANTOS R JUNQUEIRA',
    requested_by_id: 17515,
    scheduled_by_name: null,
    scheduled_by_id: null,
    surgical_order: {
      id: 545194,
      patient_internal: false,
      tecnic: 'Convencional',
      freezing: true,
      hospital_id: 6,
      room_id: 11,
      blood_reserve: true,
      cti: false,
      hospital_name: null,
      health_insurance: {
        id: 151494,
        name: 'AMIL'
      },
      patient_urgency: true,
      procedures: [
        {
          isMain: true,
          code: '40813878',
          description: 'ACESSO PERCUTANEO PARA NEFROSCOPIA',
          quantity: 1,
          surgery_id: 2375
        }
      ],
      surgery_center_name: 'CENTRO CIRURGICO (C)'
    },
    doctor: {
      id: 17138,
      name: 'MATHEUS MAGALHAES DOS SANTOS R JUNQUEIRA'
    },
    patient: {
      name: 'TIAGO DE MORAIS',
      id: 151192,
      birthday: '1986-11-05T00:00:00.000Z'
    },
    observation_to_scheduling_is_another_date: null,
    reason_to_scheduling_is_another_date: null
  },
  {
    id: 120,
    general_observation: 'asdasdsadsadasdsa EU QUE FIZ',
    status: 'analyze',
    time: {
      requested_time: null,
      justificative: null,
      predicted_time: '02:30',
      surgery_time: null
    },
    surgery_day: null,
    equipaments: [
      {
        name: 'asdasdsa',
        isSolicitation: true
      },
      {
        name: 'EQUIPAMENTO DE HEMODINAMICA',
        code: 216,
        isSolicitation: false
      }
    ],
    appointments: [
      {
        room_id: 53,
        start_date: '2023-03-29T12:00:00.000Z',
        end_date: '2023-03-29T14:00:00.000Z',
        justificative: '',
        any_time: true,
        status: 'pre-scheduling',
        is_main: true,
        scheduling: null,
        id: 236,
        hour: '',
        time: '02:30',
        is_preferential: false
      }
    ],
    anesthetist: {
      type: 'local-anesthesia'
    },
    createdAt: '2023-03-24T15:19:07.000Z',
    updatedAt: '2023-03-24T15:19:07.000Z',
    requested_by_name: 'MATHEUS MAGALHAES DOS SANTOS R JUNQUEIRA',
    requested_by_id: 17515,
    scheduled_by_name: null,
    scheduled_by_id: null,
    surgical_order: {
      id: 545169,
      patient_internal: true,
      tecnic: 'Convencional',
      freezing: true,
      hospital_id: 6,
      room_id: 11,
      blood_reserve: true,
      cti: true,
      hospital_name: null,
      health_insurance: {
        id: 151463,
        name: 'AMAGIS'
      },
      patient_urgency: false,
      procedures: [
        {
          isMain: true,
          code: '31002285',
          description: ' COLOCACAO DE BANDA GASTRICA POR VIDEOLA',
          quantity: 1,
          surgery_id: 6124
        }
      ],
      surgery_center_name: 'CENTRO CIRURGICO (C)'
    },
    doctor: {
      id: 17138,
      name: 'MATHEUS MAGALHAES DOS SANTOS R JUNQUEIRA'
    },
    patient: {
      name: 'JOAO MARCUS',
      id: 956946,
      birthday: '1970-01-01T00:00:00.000Z'
    },
    observation_to_scheduling_is_another_date: null,
    reason_to_scheduling_is_another_date: null
  },
  {
    id: 186,
    general_observation:
      'teste testteste testteste testteste testteste testteste testteste testteste testteste testteste testteste test',
    status: 'analyze',
    time: {
      requested_time: '03:30',
      justificative: 'Paciente teste',
      predicted_time: '02:30',
      surgery_time: null
    },
    surgery_day: null,
    equipaments: [],
    appointments: [
      {
        room_id: 53,
        start_date: '2023-04-03T12:30:00.000Z',
        end_date: '2023-04-03T16:00:00.000Z',
        justificative: '',
        any_time: false,
        status: 'pre-scheduling',
        is_main: true,
        scheduling: null,
        id: 387,
        hour: '12:30',
        time: '03:30',
        is_preferential: false
      }
    ],
    anesthetist: {
      type: 'choose-anesthetist',
      code: 53595,
      name: 'ALANA BRUNETTO SABADIN'
    },
    createdAt: '2023-04-03T15:12:21.000Z',
    updatedAt: '2023-04-03T15:12:21.000Z',
    requested_by_name: 'MATHEUS MAGALHAES DOS SANTOS R JUNQUEIRA',
    requested_by_id: 17515,
    scheduled_by_name: null,
    scheduled_by_id: null,
    surgical_order: {
      id: 545256,
      patient_internal: false,
      tecnic: 'Convencional',
      freezing: false,
      hospital_id: 6,
      room_id: 11,
      blood_reserve: false,
      cti: false,
      hospital_name: 'HOSPITAL MATER DEI S/A CONTORNO',
      health_insurance: {
        id: 151560,
        name: 'BENEFICIOS SAUDE MATER DEI'
      },
      patient_urgency: false,
      procedures: [
        {
          isMain: true,
          code: '31002285',
          description: ' COLOCACAO DE BANDA GASTRICA POR VIDEOLA',
          quantity: 1,
          surgery_id: 6124
        }
      ],
      surgery_center_name: 'CENTRO CIRURGICO (C)'
    },
    doctor: {
      id: 17138,
      name: 'MATHEUS MAGALHAES DOS SANTOS R JUNQUEIRA'
    },
    patient: {
      name: 'ROSACILDA OLIVEIRA MATOS ARAUJO',
      id: 638173,
      birthday: '1956-03-04T00:00:00.000Z'
    },
    observation_to_scheduling_is_another_date: null,
    reason_to_scheduling_is_another_date: null
  },
  {
    id: 197,
    general_observation: 'dsadasdas',
    status: 'analyze',
    time: {
      requested_time: null,
      justificative: null,
      predicted_time: '02:30',
      surgery_time: null
    },
    surgery_day: null,
    equipaments: [],
    appointments: [
      {
        room_id: 53,
        start_date: '2023-04-04T15:00:00.000Z',
        end_date: '2023-04-04T17:30:00.000Z',
        justificative: '',
        any_time: true,
        status: 'pre-scheduling',
        is_main: true,
        scheduling: null,
        id: 399,
        hour: '',
        time: '02:30',
        is_preferential: false
      }
    ],
    anesthetist: {
      type: 'scale'
    },
    createdAt: '2023-04-04T17:39:25.000Z',
    updatedAt: '2023-04-04T17:39:25.000Z',
    requested_by_name: 'BARBARA PACE SILVA ASSIS CARVALHO',
    requested_by_id: 10660,
    scheduled_by_name: null,
    scheduled_by_id: null,
    surgical_order: {
      id: 572110,
      patient_internal: false,
      tecnic: 'Convencional',
      freezing: false,
      hospital_id: 6,
      room_id: 11,
      blood_reserve: true,
      cti: false,
      hospital_name: 'HOSPITAL MATER DEI S/A CONTORNO',
      health_insurance: {
        id: 151575,
        name: 'AMAGIS'
      },
      patient_urgency: false,
      procedures: [
        {
          isMain: true,
          code: '31002285',
          description: ' COLOCACAO DE BANDA GASTRICA POR VIDEOLA',
          quantity: 1,
          surgery_id: 6124
        }
      ],
      surgery_center_name: 'CENTRO CIRURGICO (C)'
    },
    doctor: {
      id: 1142,
      name: 'BARBARA PACE SILVA ASSIS CARVALHO'
    },
    patient: {
      name: 'JOAO MARCUS',
      id: 956946,
      birthday: '1994-11-06T00:00:00.000Z'
    },
    observation_to_scheduling_is_another_date: null,
    reason_to_scheduling_is_another_date: null
  },
  {
    id: 198,
    general_observation: 'nn',
    status: 'analyze',
    time: {
      requested_time: null,
      justificative: null,
      predicted_time: '03:00',
      surgery_time: null
    },
    surgery_day: null,
    equipaments: [],
    appointments: [
      {
        room_id: 53,
        start_date: '2023-06-15T07:00:00.000Z',
        end_date: '2023-06-15T10:00:00.000Z',
        justificative: '',
        any_time: false,
        status: 'pre-scheduling',
        is_main: true,
        scheduling: null,
        id: 402,
        hour: '07:00',
        time: '03:00',
        is_preferential: false
      }
    ],
    anesthetist: {
      type: 'local-anesthesia'
    },
    createdAt: '2023-04-04T20:18:28.000Z',
    updatedAt: '2023-04-04T20:18:28.000Z',
    requested_by_name: 'BARBARA PACE SILVA ASSIS CARVALHO',
    requested_by_id: 10660,
    scheduled_by_name: null,
    scheduled_by_id: null,
    surgical_order: {
      id: 572106,
      patient_internal: false,
      tecnic: 'Convencional',
      freezing: true,
      hospital_id: 6,
      room_id: 11,
      blood_reserve: true,
      cti: false,
      hospital_name: 'HOSPITAL MATER DEI S/A CONTORNO',
      health_insurance: {
        id: 151569,
        name: 'BRADESCO'
      },
      patient_urgency: false,
      procedures: [
        {
          isMain: true,
          code: '79901598',
          description: 'BLEFAROPLASTIA SUPERIOR E/OU INFERIOR',
          quantity: 1,
          surgery_id: 6642
        }
      ],
      surgery_center_name: 'CENTRO CIRURGICO (C)'
    },
    doctor: {
      id: 1142,
      name: 'BARBARA PACE SILVA ASSIS CARVALHO'
    },
    patient: {
      name: 'MARIA JOSE DOS REIS SILVA',
      id: 122631,
      birthday: '1952-07-28T00:00:00.000Z'
    },
    observation_to_scheduling_is_another_date: null,
    reason_to_scheduling_is_another_date: null
  },
  {
    id: 199,
    general_observation: 'm',
    status: 'analyze',
    time: {
      requested_time: null,
      justificative: null,
      predicted_time: '03:00',
      surgery_time: null
    },
    surgery_day: null,
    equipaments: [],
    appointments: [
      {
        room_id: 54,
        start_date: '2023-06-15T07:00:00.000Z',
        end_date: '2023-06-15T10:00:00.000Z',
        justificative: '',
        any_time: false,
        status: 'pre-scheduling',
        is_main: true,
        scheduling: null,
        id: 403,
        hour: '07:00',
        time: '03:00',
        is_preferential: false
      }
    ],
    anesthetist: {
      type: 'local-anesthesia'
    },
    createdAt: '2023-04-04T20:26:27.000Z',
    updatedAt: '2023-04-04T20:26:27.000Z',
    requested_by_name: 'BARBARA PACE SILVA ASSIS CARVALHO',
    requested_by_id: 10660,
    scheduled_by_name: null,
    scheduled_by_id: null,
    surgical_order: {
      id: 572106,
      patient_internal: false,
      tecnic: 'Convencional',
      freezing: true,
      hospital_id: 6,
      room_id: 11,
      blood_reserve: true,
      cti: false,
      hospital_name: 'HOSPITAL MATER DEI S/A CONTORNO',
      health_insurance: {
        id: 151569,
        name: 'BRADESCO'
      },
      patient_urgency: false,
      procedures: [
        {
          isMain: true,
          code: '79901598',
          description: 'BLEFAROPLASTIA SUPERIOR E/OU INFERIOR',
          quantity: 1,
          surgery_id: 6642
        }
      ],
      surgery_center_name: 'CENTRO CIRURGICO (C)'
    },
    doctor: {
      id: 1142,
      name: 'BARBARA PACE SILVA ASSIS CARVALHO'
    },
    patient: {
      name: 'MARIA JOSE DOS REIS SILVA',
      id: 122631,
      birthday: '1952-07-28T00:00:00.000Z'
    },
    observation_to_scheduling_is_another_date: null,
    reason_to_scheduling_is_another_date: null
  },
  {
    id: 200,
    general_observation: 'j',
    status: 'analyze',
    time: {
      requested_time: null,
      justificative: null,
      predicted_time: '03:00',
      surgery_time: null
    },
    surgery_day: null,
    equipaments: [],
    appointments: [
      {
        room_id: 55,
        start_date: '2023-06-15T07:00:00.000Z',
        end_date: '2023-06-15T10:00:00.000Z',
        justificative: '',
        any_time: false,
        status: 'pre-scheduling',
        is_main: true,
        scheduling: null,
        id: 404,
        hour: '07:00',
        time: '03:00',
        is_preferential: false
      }
    ],
    anesthetist: {
      type: 'local-anesthesia'
    },
    createdAt: '2023-04-04T20:30:16.000Z',
    updatedAt: '2023-04-04T20:30:16.000Z',
    requested_by_name: 'BARBARA PACE SILVA ASSIS CARVALHO',
    requested_by_id: 10660,
    scheduled_by_name: null,
    scheduled_by_id: null,
    surgical_order: {
      id: 572106,
      patient_internal: false,
      tecnic: 'Convencional',
      freezing: true,
      hospital_id: 6,
      room_id: 11,
      blood_reserve: true,
      cti: false,
      hospital_name: 'HOSPITAL MATER DEI S/A CONTORNO',
      health_insurance: {
        id: 151569,
        name: 'BRADESCO'
      },
      patient_urgency: false,
      procedures: [
        {
          isMain: true,
          code: '79901598',
          description: 'BLEFAROPLASTIA SUPERIOR E/OU INFERIOR',
          quantity: 1,
          surgery_id: 6642
        }
      ],
      surgery_center_name: 'CENTRO CIRURGICO (C)'
    },
    doctor: {
      id: 1142,
      name: 'BARBARA PACE SILVA ASSIS CARVALHO'
    },
    patient: {
      name: 'MARIA JOSE DOS REIS SILVA',
      id: 122631,
      birthday: '1952-07-28T00:00:00.000Z'
    },
    observation_to_scheduling_is_another_date: null,
    reason_to_scheduling_is_another_date: null
  }
]

export const tableColumns = [
  {
    name: 'patient_urgency',
    label: ' ',
    options: { filter: false, sort: false }
  },
  {
    name: 'patient_internal',
    label: ' ',
    options: { filter: false, sort: false }
  },
  {
    name: 'robotic',
    label: ' ',
    options: { filter: false, sort: false }
  },
  {
    name: 'hemodinamic',
    label: ' ',
    options: { filter: false, sort: false }
  },
  {
    name: 'surgical_order_id',
    label: 'N° Aviso',
    options: { filter: false, sort: false }
  },
  {
    name: 'patient_name',
    label: 'Paciente',
    options: { filter: false, sort: false }
  },
  {
    name: 'doctor_name',
    label: 'Médico responsável',
    options: { filter: false, sort: false }
  },
  {
    name: 'main_surgery',
    label: 'Cirurgia principal',
    options: { filter: false, sort: false }
  },
  {
    name: 'health_insurance',
    label: 'Convênio',
    options: { filter: false, sort: false }
  },
  {
    name: 'createdAt',
    label: 'Dt. criação aviso',
    options: { filter: false, sort: false }
  },
  {
    name: 'surgery_day',
    label: 'Dt. agendada',
    options: { filter: false, sort: false }
  },
  {
    name: 'interactions',
    label: 'Interações',
    options: { filter: false, sort: false }
  },
  {
    name: 'situation',
    label: 'Situação',
    options: { filter: false, sort: false }
  },
  {
    name: 'created_by',
    label: 'Criado por',
    options: { filter: false, sort: false }
  }
]
